import React from 'react';
import PropTypes from 'prop-types'
import './doxModal.scss'
import { useTranslationContext } from '../hooks/useTranslationContextHook';
import CloseIcon from '@mui/icons-material/Close';
import DoxUploaderStatusIcon from './doxUploaderStatusIcon';
import classnames from 'classnames';

const DoxModalHeader = ({ onClose, titleKey, titleKeyParams, fileUploadStatus, hideCloseButton = false, showStatusIcon = false }) => {  
    const translateString = useTranslationContext()

    return (
        <div className='hrb-columns dox-modal-header'>
            
            <div className={showStatusIcon ? 'hrb-column hrb-is-1' : 'dox-modal-no-icon'} >
                { showStatusIcon && <DoxUploaderStatusIcon uploadStatus={fileUploadStatus} /> }
            </div>
            <div className='hrb-column hrb-is-10 dox-modal-title'>
                <h4>{translateString(titleKey, titleKeyParams)}</h4>
            </div>
            {!hideCloseButton &&
                <div className={classnames('dox-modal-exit-button', { 'hrb-column hrb-is-1': showStatusIcon })} onClick={onClose}>
                    <CloseIcon />
                </div>
            }
        </div>
    )
}

DoxModalHeader.propTypes = {
    onClose: PropTypes.func.isRequired,
    titleKey: PropTypes.string.isRequired,
    titleKeyParams: PropTypes.object,
    hideCloseButton: PropTypes.bool
}

export default DoxModalHeader;